<template>
<div class="wl-managerWordDetail-web">
    <div class="managerWord-center-content" style="width:100%;">
        <div class="new-breadcrumb-trail">
            <h2>管理办法</h2>
            <div class="crumbs-text">
                <i class="wl-icon-zhuye1"></i>
                <span>当前位置：</span>
                <span @click="goHome">网站首页</span>
                <span>></span>
                <span @click="goNews">
                    <span>管理办法</span>
                </span>
                <span>></span>
                <span>{{managerWordInfo.Title}}</span>
            </div>
        </div>
        <div class="new-center-detail">
            <div class="new-center-title">
                <h3 class="h3-news-title">{{managerWordInfo.Title}}</h3>
                <p class="p-news-date">发布时间：{{dateCreated}}</p>
                <div class="class-news-content">
                    <p v-html="managerWordInfo.Content"></p>
                </div>
            </div>
        </div>
        <div style="margin-left:250px;">
            <!-- <studySource></studySource> -->
        </div>
    </div>
    <div class="ph-new-center-content">
        <div class="crumbs-text">
            <div style="padding:0 20px;">
                <i class="wl-icon-zhuye1"></i>
                <span @click="goHome" style="cursor: pointer;">首页</span>
                <span>></span>
                <span @click="getNewCenter(1)">管理办法</span>
            </div>
        </div>
        <div class="new-center-detail">
            <div class="new-center-title">
                <h3 class="h3-news-title">{{managerWordInfo.Title}}</h3>
                <p class="p-news-date">发布时间：{{dateCreated}}</p>
                <div class="class-news-content">
                    <p v-html="managerWordInfo.Content"></p>
                </div>
            </div>
        </div>
        <div style="margin-left:250px;">
            <!-- <studySource></studySource> -->
        </div>
    </div>
</div>
</template>

<script>
import studySource from "page/component/school/studySource.vue";
export default {
    name: "Detail",
    components: {
        studySource
    },
    props: {
        managerWordId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            managerWordInfo: {},
            dateCreated: "",
            isShow: 1,
            imgcen: require("../../assets/images/bg-news.png")
        };
    },
    created() {
        this.getNewsInfo();
    },
    methods: {
        getNewCenter(num) {
            this.$router.push({
                name: "managerWordList",
                params: {
                    isTab: num
                }
            });
        },
        goHome() {
            this.$router.push({
                name: "xHome"
            });
        },
        goNews() {
            this.$router.push({
                name: "managerWordList"
            });
        },
        getNewsInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/ManagerWordCom/getManagerWordInfo", {
                    id: that.managerWordId
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.managerWordInfo = rst.managerWordInfo;
                        that.dateCreated = rst.dateCreated;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        }
    }
};
</script>
